export const RETAILER_SLUG_ROMANIA = 'romania';
export const RETAILER_SLUG_JAPAN = 'japan';

// Types of store
// ! Convert to selectors
export const RetailerLocationStoreType = {
  dutyFree: 'duty-free',
  ecommerce: 'e-commerce',
  events: 'events',
  main: 'main',
} as const;

export const RETAILER_TAG_EXTERNAL_REDIRECT_URL = 'external_redirect_url';
export const RETAILER_TAG_EXTERNAL_REFERENCE_ID = 'external_reference_id';
export const EXTERNAL_USER_ID = 'external_user_id';
